"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'content-settings/v1/site-maps';

var SitemapsAPI =
/*#__PURE__*/
function () {
  function SitemapsAPI() {
    (0, _classCallCheck2.default)(this, SitemapsAPI);
  }

  (0, _createClass2.default)(SitemapsAPI, null, [{
    key: "getSitemaps",
    value: function getSitemaps() {
      return _apiClient.default.get(API_BASE, {
        query: {
          limit: 1000
        }
      });
    }
  }, {
    key: "updateSitemap",
    value: function updateSitemap(data) {
      return _apiClient.default.put(API_BASE + "/" + data.id, {
        data: data
      });
    }
  }]);
  return SitemapsAPI;
}();

exports.default = SitemapsAPI;
module.exports = exports.default;